import styled, { css } from 'styled-components';

import { Flex, FlexProps } from '../../base';
import { BadgeProps } from './Badge';

const badgeColor = ({ theme, variant }: typeof BadgeContainer) => {
  switch (variant) {
    case 'warning':
      return css`
        background-color: ${theme.mosaiq.colors.sandyHeath};
        border-color: ${theme.mosaiq.colors.navajoWhite};
        color: ${theme.mosaiq.colors.sandyBrown};
      `;
    case 'success':
      return css`
        background-color: ${theme.mosaiq.colors.emeraldWhite};
        border-color: ${theme.mosaiq.colors.mould};
        color: ${theme.mosaiq.colors.emerald};
      `;
    case 'error':
      return css`
        background-color: ${theme.mosaiq.colors.apricotPeach};
        border-color: ${theme.mosaiq.colors.coral};
        color: ${theme.mosaiq.colors.coral};
      `;
    case 'info':
      return css`
        background-color: ${theme.mosaiq.colors.portage};
        border-color: ${theme.mosaiq.colors.persianBlue};
        color: ${theme.mosaiq.colors.persianBlue};
      `;
    default:
      return css`
        background-color: ${theme.mosaiq.colors.grey};
        border-color: ${theme.mosaiq.colors.grey60};
        color: ${theme.mosaiq.colors.body};
      `;
  }
};

export const BadgeContainer = styled(Flex).attrs({
  alignItems: 'center',
  gap: 0.5,
})<BadgeProps & FlexProps>`
  display: flex;
  border-radius: 1em;
  padding: ${({ theme }) => `${theme.mosaiq.spacing(0.25)}px ${theme.mosaiq.spacing(1)}px`};
  border: 1px solid;
  ${badgeColor}
  ${({ theme }) => theme.mosaiq.typography.title7()}
`;
